import auth from "./auth";

export const AUTH_NAMESPACE = "auth";

export const fromAuth = name => `${AUTH_NAMESPACE}/${name}`;

export default auth;
